import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { SelectionSetRecord } from "@ServerTypes/selectionSet/selectionSet.schema";

const selectedSetSlice = createSlice({
  name: "selectedSet",
  initialState: "-1",
  reducers: {
    setSelectedSet: (_state: string, action: PayloadAction<string>) => action.payload,
  },
});

const selectionListSlice = createSlice({
  name: "selectionList",
  initialState: [] as SelectionSetRecord[],
  reducers: {
    setSelectionList: (_state: SelectionSetRecord[], action: PayloadAction<SelectionSetRecord[]>) => action.payload,
  },
});

const selectionListIdObjSlice = createSlice({
  name: "selectionListIdObj",
  initialState: {} as Record<string, boolean>,
  reducers: {
    setSelectionListIdObj: (_state: Record<string, boolean>, action: PayloadAction<Record<string, boolean>>) =>
      action.payload,
  },
});

const selectedSelectionSetItemsListSlice = createSlice({
  name: "selectedSelectionSetItemsList",
  initialState: [] as SelectionSetRecord[],
  reducers: {
    setSelectedSelectionSetItemsList: (_state: SelectionSetRecord[], action: PayloadAction<SelectionSetRecord[]>) =>
      action.payload,
  },
});

const selectionSetUpdatedSlice = createSlice({
  name: "selectionSetUpdated",
  initialState: false,
  reducers: {
    setSelectionSetUpdated: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

export const { setSelectedSet } = selectedSetSlice.actions;
export const { setSelectionList } = selectionListSlice.actions;
export const { setSelectionListIdObj } = selectionListIdObjSlice.actions;
export const { setSelectedSelectionSetItemsList } = selectedSelectionSetItemsListSlice.actions;
export const { setSelectionSetUpdated } = selectionSetUpdatedSlice.actions;

export const selectedSet = selectedSetSlice.reducer;
export const selectionList = selectionListSlice.reducer;
export const selectionListIdObj = selectionListIdObjSlice.reducer;
export const selectedSelectionSetItemsList = selectedSelectionSetItemsListSlice.reducer;
export const selectionSetUpdated = selectionSetUpdatedSlice.reducer;
